import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Partners', path: '/partners' }, 
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <div className={`fixed w-full z-[100] transition-all duration-500 ease-in-out flex justify-center ${isScrolled ? 'top-0' : 'top-6'}`}>
      <nav 
        className={`flex justify-between items-center transition-all duration-500 ease-in-out relative ${
          isScrolled 
            ? 'w-full py-4 px-8 md:px-16 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm rounded-none' 
            : 'w-[95%] md:w-[85%] max-w-7xl py-4 px-8 md:px-10 bg-white/80 backdrop-blur-xl border border-gray-200 shadow-[0_8px_30px_rgb(0,0,0,0.08)] rounded-full'
        }`}
      >
        {/* Logo */}
        <Link to="/" className="font-bold text-2xl tracking-wide leading-tight text-slate-900 no-underline flex flex-col z-[110]">
          Spacezant
          {/* <span className={`text-slate-500 font-medium tracking-wider transition-all duration-300 ${isScrolled ? 'text-[10px] mt-1' : 'text-xs mt-0.5'}`}>
            Private Limited
          </span> */}
        </Link>
        
        {/* Desktop Links */}
        <ul className="hidden lg:flex space-x-8 text-sm font-semibold text-slate-600 items-center">
          {navLinks.map((link) => (
            <li key={link.name} className={`cursor-pointer transition-colors relative group ${isActive(link.path) ? 'text-[#e85d04]' : 'hover:text-[#e85d04]'}`}>
              <Link to={link.path}>{link.name}</Link>
              <span className={`absolute -bottom-1 left-0 w-full h-[2px] bg-[#e85d04] transition-transform duration-300 ${isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`}></span>
            </li>
          ))}
          <li className="ml-4">
            <svg className="w-5 h-5 text-slate-400 hover:text-[#e85d04] cursor-pointer transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </li>
        </ul>

        {/* Mobile Menu Button (Hamburger) */}
        <button 
          className="lg:hidden p-2 text-slate-900 focus:outline-none z-[110]"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <div className="w-6 h-5 relative flex flex-col justify-between">
            <span className={`w-full h-0.5 bg-slate-900 rounded-full transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-full h-0.5 bg-slate-900 rounded-full transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-full h-0.5 bg-slate-900 rounded-full transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2.5' : ''}`}></span>
          </div>
        </button>

        {/* Mobile Dropdown Menu (Button removed, clean links only) */}
        <div 
          className={`absolute top-[calc(100%+1rem)] left-0 right-0 bg-white/95 backdrop-blur-2xl border border-gray-200 shadow-2xl rounded-3xl lg:hidden transition-all duration-300 ease-in-out transform ${
            isMenuOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-4 invisible'
          }`}
        >
          <ul className="flex flex-col p-6 space-y-4">
            {navLinks.map((link) => (
              <li key={link.name} className="border-b border-gray-50 last:border-none pb-2">
                <Link 
                  to={link.path} 
                  onClick={() => setIsMenuOpen(false)}
                  className={`block text-lg font-bold transition-colors ${isActive(link.path) ? 'text-[#e85d04]' : 'text-slate-700'}`}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;